import { render, staticRenderFns } from "./FormattedNumberField.vue?vue&type=template&id=21743701&"
import script from "./FormattedNumberField.vue?vue&type=script&lang=js&"
export * from "./FormattedNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21743701')) {
      api.createRecord('21743701', component.options)
    } else {
      api.reload('21743701', component.options)
    }
    module.hot.accept("./FormattedNumberField.vue?vue&type=template&id=21743701&", function () {
      api.rerender('21743701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/components/formatted/FormattedNumberField.vue"
export default component.exports